import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export default function Header({ transparent = false }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API}/site-settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const whatsappLink = `https://wa.me/${(settings?.whatsapp_number || '+905444720713').replace(/[^0-9]/g, '')}`;
  const siteName = settings?.site_name || 'KARGA AKADEMİ';
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 ${transparent ? 'bg-black/60' : 'bg-[#050505]'} backdrop-blur-xl border-b border-white/10`}>
      <div className="container mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center pl-1" data-testid="header-logo">
          <span className="text-2xl font-black tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>{siteName}</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          <Link to="/" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-home">Ana Sayfa</Link>
          <Link to="/about" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-about">Hakkımızda</Link>
          <Link to="/packages" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-packages">Paketlerimiz</Link>
          <Link to="/blog" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/contact" className="text-sm text-[#A1A1AA] hover:text-white transition-colors" data-testid="nav-contact">İletişim</Link>
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Button onClick={() => navigate(user.role === 'admin' ? '/admin' : user.role === 'mentor' ? '/mentor' : '/dashboard')} className="bg-[#B026FF] hover:bg-[#C966FF] text-white" data-testid="header-dashboard-btn">
              Panelim
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate('/login')} className="text-white hover:text-[#B026FF]" data-testid="header-login-btn">Giriş Yap</Button>
              <Button onClick={() => navigate('/register')} className="bg-[#B026FF] hover:bg-[#C966FF] text-white shadow-lg shadow-[#B026FF]/20" data-testid="header-register-btn">Kaydol</Button>
            </>
          )}
        </div>

        <button className="lg:hidden text-white" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-btn">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobileOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} /></svg>
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10 p-4 space-y-3">
          <Link to="/" className="block text-sm text-[#A1A1AA] hover:text-white py-2" onClick={() => setMobileOpen(false)}>Ana Sayfa</Link>
          <Link to="/about" className="block text-sm text-[#A1A1AA] hover:text-white py-2" onClick={() => setMobileOpen(false)}>Hakkımızda</Link>
          <Link to="/packages" className="block text-sm text-[#A1A1AA] hover:text-white py-2" onClick={() => setMobileOpen(false)}>Paketlerimiz</Link>
          <Link to="/blog" className="block text-sm text-[#A1A1AA] hover:text-white py-2" onClick={() => setMobileOpen(false)}>Blog</Link>
          <Link to="/contact" className="block text-sm text-[#A1A1AA] hover:text-white py-2" onClick={() => setMobileOpen(false)}>İletişim</Link>
          <div className="flex gap-3 pt-2">
            {user ? (
              <Button onClick={() => { navigate(user.role === 'admin' ? '/admin' : user.role === 'mentor' ? '/mentor' : '/dashboard'); setMobileOpen(false); }} className="bg-[#B026FF] hover:bg-[#C966FF] text-white w-full">Panelim</Button>
            ) : (
              <>
                <Button variant="ghost" onClick={() => { navigate('/login'); setMobileOpen(false); }} className="text-white flex-1">Giriş Yap</Button>
                <Button onClick={() => { navigate('/register'); setMobileOpen(false); }} className="bg-[#B026FF] hover:bg-[#C966FF] text-white flex-1">Kaydol</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
